module.exports = __webpack_public_path__ + "static/img/wecom_logo.945bb95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wecom_logo.png
// module id = TfO3
// module chunks = 1